export default __webpack_public_path__ + "static/media/premium.e8320448.svg";